import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import { createRouter, RouterProvider } from '@tanstack/react-router'

import { routeTree } from './routeTree.gen'
import { LoadingScreen } from '@/components/widgets/loading-screen'
import { ErrorScreen } from '@/components/widgets/error-screen/error-screen'
import { NotFound } from '@/components/widgets/not-found/not-found'
import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://bac9cb410d4eec7bb1227fdc1a2aebb3@o4509280197410816.ingest.de.sentry.io/4509314620981328',
  sendDefaultPii: true,
  integrations: [Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

const router = createRouter({
  routeTree,
  basepath: '',
  defaultPendingComponent: LoadingScreen,
  defaultPendingMs: 1000,
  defaultErrorComponent: ErrorScreen,
  defaultNotFoundComponent: NotFound,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  )
}
